<template>
  <div class="flex flex-col c-box">
    <div class="header-box">
      <p class="nowrap" style="width: 90%; margin: 0px auto">
        {{ dialogTitle }}
      </p>
      <div class="close-box" @click="closePreview">
        <a-icon type="rollback" />
      </div>
    </div>
    <!-- 阿里云视频 -->
    <div class="centent-box flex-1 flex" v-if="sj && sj.aliId">
      <vue-aliplayer-v2
        class="VueAliplayerV2"
        ref="VueAliplayerV2"
        style="height: 700px"
        :source="previewUrl"
        :options="options"
      />
    </div>
    <!-- 图片 -->
    <div class="centent-box" v-else-if="previewUrl && isImageFile">
      <img :src="sjs(previewUrl)" alt="" />
    </div>
    <!-- 其它文件统一 iframe（对齐 newpreview，避免 doc/pdf 弹窗空白） -->
    <div class="centent-box flex-1 flex" v-else-if="previewUrl">
      <iframe
        width="100%"
        :src="sjs(previewUrl)"
        name="file-preview"
        scrolling-y="auto"
        frameborder="0"
        style="width: 100%; height: 100%; background: #fff"
      ></iframe>
    </div>
  </div>
</template>

<script>
import { postAction, post1Action } from "@/api/index";
import { baseURL } from "@/utils/request.js";
import VueAliplayerV2 from "vue-aliplayer-v2";
export default {
  data() {
    return {
      options: {
        vid: "",
        playauth: "",
        autoplay: true,
        controlBarVisibility: "always",
      },
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    previewUrl: {
      type: String,
      default: "",
    },
    dialogTitle: {
      type: String,
      default: "文件预览",
    },
    sj: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    VueAliplayerV2,
  },
  computed: {
    urlLower() {
      return String(this.previewUrl || "").toLowerCase();
    },
    isImageFile() {
      return /\.(png|jpe?g|gif|bmp|webp)(\?|$)/i.test(this.urlLower);
    },
  },
  mounted() {
    if (this.sj && this.sj.aliId) {
      const params = new FormData();
      params.append("videoId", this.sj.aliId);
      postAction("/sys/video/videoPlayAuth", params).then((result) => {
        if (result.code == 200) {
          this.options.playauth = result.result;
          this.options.vid = this.sj.aliId;
          this.getdata();
        }
      });
    }
  },
  methods: {
    getdata() {
      const params = new FormData();
      params.append("videoId", this.sj.aliId);
      post1Action("/sys/video/playInfo", params).then((res) => {
        if (res.code == 200) {
          this.previewUrl = res.result.previewPath;
        }
      });
    },
    sjs(url) {
      if (!url) return "";
      if (/^https?:\/\//i.test(url)) return url;
      return baseURL + url;
    },
    closePreview() {
      this.$emit("closePreview");
    },
  },
};
</script>

<style scoped lang="scss">
.c-box {
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow-y: auto;

  .header-box {
    height: 60px;
    line-height: 60px;
    position: relative;
    text-align: center;
    background: #2155b5;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #fff;
  }
  .nowrap {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .close-box {
    position: absolute;
    right: 20px;
    top: 0;
    cursor: pointer;
    font-size: 22px;
  }
  .centent-box {
    height: calc(100% - 60px);
    width: 100%;
    overflow: auto;
    img {
      max-width: 100%;
      display: block;
      margin: 0 auto;
    }
  }
}
</style>
